import { AddOrganisationDialog } from '@/features/organisations/components/dialogs';
import { AddProjectDialog } from '@/features/projects/components/dialogs';
import type { ReactElement } from 'react';

type AppDialogsState = {
  addProjectDialog: {
    open: boolean;
    saving: boolean;
    onboarding: boolean;
    name: string;
    errorMessage: string | null;
    onNameChange: (value: string) => void;
    onClose: () => void;
    onSave: () => Promise<void>;
  };
  addOrganisationDialog: {
    open: boolean;
    saving: boolean;
    name: string;
    errorMessage: string | null;
    onNameChange: (value: string) => void;
    onClose: () => void;
    onSave: () => Promise<void>;
  };
};

type AppDialogHostProps = {
  dialogs: AppDialogsState;
};

export const AppDialogHost = ({ dialogs }: AppDialogHostProps): ReactElement => {
  return (
    <>
      <AddProjectDialog
        open={dialogs.addProjectDialog.open}
        saving={dialogs.addProjectDialog.saving}
        required={dialogs.addProjectDialog.onboarding}
        title={dialogs.addProjectDialog.onboarding ? 'Add Your First Project' : 'Add Project'}
        confirmLabel="Add Project"
        name={dialogs.addProjectDialog.name}
        errorMessage={dialogs.addProjectDialog.errorMessage}
        onNameChange={dialogs.addProjectDialog.onNameChange}
        onClose={dialogs.addProjectDialog.onClose}
        onSave={dialogs.addProjectDialog.onSave}
      />
      <AddOrganisationDialog
        open={dialogs.addOrganisationDialog.open}
        saving={dialogs.addOrganisationDialog.saving}
        name={dialogs.addOrganisationDialog.name}
        errorMessage={dialogs.addOrganisationDialog.errorMessage}
        onNameChange={dialogs.addOrganisationDialog.onNameChange}
        onClose={dialogs.addOrganisationDialog.onClose}
        onSave={dialogs.addOrganisationDialog.onSave}
      />
    </>
  );
};
